import { render, staticRenderFns } from "./PaySlip.vue?vue&type=template&id=039c7198&scoped=true"
import script from "./PaySlip.vue?vue&type=script&lang=js"
export * from "./PaySlip.vue?vue&type=script&lang=js"
import style0 from "./PaySlip.vue?vue&type=style&index=0&id=039c7198&prod&lang=css"
import style1 from "./PaySlip.vue?vue&type=style&index=1&id=039c7198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c7198",
  null
  
)

export default component.exports